<template>
  <!-- Page Header Start-->
  <div :class="headerClass">
    <div class="main-header-right row">
      <div class="main-header-left d-lg-none">
        <div class="logo-wrapper">
          <router-link to="/">
            <img
              class="blur-up lazyloaded"
              src="../../assets/images/dashboard/sablior-2-150x52.png"
              alt=""
          /></router-link>
        </div>
      </div>
      <div class="mobile-sidebar" v-if="!isGlobalDashboard">
        <div class="media-body text-right switch-sm">
          <label class="switch"
            ><a @click="toggle_sidebar"
              ><i id="sidebar-toggle"
                ><feather type="align-left"></feather></i></a
          ></label>
        </div>
      </div>
      <div class="nav-right col">
        <ul class="nav-menus" :class="headerMenu?'open':''">

          <!-- Boutique active + menu de changement de boutique -->
          <li class="onhover-dropdown store-switcher">
            <a class="txt-dark d-flex align-items-center">
              <feather type="shopping-bag" style="width:16px;height:16px"></feather>
              <h6 class="mb-0 mx-1 text-truncate" style="max-width: 140px;">{{ currentStoreLabel }}</h6>
              <feather type="chevron-down" style="width:14px;height:14px"></feather>
            </a>
            <ul class="language-dropdown onhover-show-div p-20">
              <li @click="goGlobalDashboard">
                <a>
                  <feather type="grid" style="width:14px;height:14px"></feather>
                  All stores
                </a>
              </li>
              <li
                v-for="store in stores"
                :key="store.id"
                :class="{ active: (store.host || store.id) === selectedHost }"
                @click="selectStore(store)"
              >
                <a>
                  <img v-if="store.logo" :src="store.logo" alt="" class="store-thumb" />
                  <feather v-else type="shopping-bag" style="width:14px;height:14px"></feather>
                  {{ store.host || store.id }}
                </a>
              </li>
              <li v-if="!stores.length">
                <a class="text-muted">No stores yet</a>
              </li>
            </ul>
          </li>

          <li>
            <a class="text-dark" href="#!" @click="toggle_fullscreen()"
              ><i data-feather="maximize-2"
                ><feather type="maximize-2"></feather></i
            ></a>
          </li>

          <li class="onhover-dropdown">
            <a class="txt-dark">
              <h6>{{ $i18n.locale | capitalize }}</h6></a
            >
            <ul class="language-dropdown onhover-show-div p-20">
              <li
                v-for="(l, index) in localeOptions"
                :key="index"
                @click="changeLocale(l)"
              >
                <a
                  ><i class="flag-icon flag-icon-is"
                    ><country-flag :country="l.icon" size="normal"
                  /></i>
                  {{ l.name }}</a
                >
              </li>
            </ul>
          </li>

          <!-- Notifications : dernières commandes, toutes boutiques -->
          <li class="onhover-dropdown">
            <i data-feather="bell"><feather type="bell"></feather></i>
            <span v-if="newOrdersCount" class="badge badge-primary pull-right notification-badge">{{
              newOrdersCount
            }}</span>
            <ul class="notification-dropdown onhover-show-div p-0">
              <li>
                Latest orders
                <span class="badge badge-primary pull-right">{{ recentOrders.length }}</span>
              </li>
              <li
                v-for="order in recentOrders"
                :key="order.key"
                @click="openOrderStore(order)"
              >
                <div class="media">
                  <div class="media-body">
                    <h6 class="mt-0">
                      <span class="shopping-color"><feather type="shopping-bag"></feather></span>
                      {{ order.transactionId }} · {{ order.amtLabel }}
                    </h6>
                    <p class="mb-0">
                      {{ order.site }} · {{ order.customer }} · {{ order.dateLabel }}
                    </p>
                  </div>
                </div>
              </li>
              <li v-if="!recentOrders.length" class="px-20 py-2 text-muted">
                No orders yet.
              </li>
              <li class="txt-dark"><a @click="goGlobalDashboard">All stores</a> dashboard</li>
            </ul>
          </li>

          <!-- Profil : compte réellement connecté -->
          <li class="onhover-dropdown">
            <div class="media align-items-center">
              <div class="avatar-circle" :title="userEmail">{{ initials }}</div>
            </div>
            <ul
              class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover"
            >
              <li class="profile-identity">
                <div>Signed in as</div>
                <strong class="text-truncate d-block">{{ userEmail }}</strong>
              </li>
              <li>
                <a @click="goGlobalDashboard"
                  ><feather type="grid"></feather>Global dashboard</a
                >
              </li>
              <li>
                <a @click="goProfile"
                  ><feather type="user"></feather>My profile</a
                >
              </li>
              <li>
                <a @click="goSubscription"
                  ><feather type="credit-card"></feather>Subscription</a
                >
              </li>
              <li>
                <a @click="logout"
                  ><feather type="log-out"></feather><span>Log out</span></a
                >
              </li>
            </ul>
          </li>
        </ul>
        <div class="d-lg-none mobile-toggle pull-right" @click="openHeader()">
          <feather type="more-horizontal"></feather>
        </div>
      </div>
    </div>
  </div>
  <!-- Page Header Ends -->
</template>

<script>
import firebase from '@/utils/firestore-shim';
import UserAuth from "../../auth/index.js";
import CountryFlag from "vue-country-flag";
import { localeOptions } from "../../constants/config";
import { mapActions } from "vuex";
import {
  getSelectedHost,
  setSelectedHost,
  parseOrderDate,
  parseNumber,
  normalizeStatus,
  fullName,
  formatMoney,
  formatDate
} from "../../utils/store-stats";

// Boutiques volontairement masquées dans le sélecteur du header (demande
// du propriétaire). La boutique existe toujours en base ; elle n'est
// simplement plus proposée dans le menu de changement de boutique.
const HIDDEN_STORES = ["iqdomus.com"];

export default {
  name: "Header",
  components: {
    CountryFlag
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.selectedHost = getSelectedHost() || "";
    this.loadStores().then(() => this.loadRecentOrders());
  },
  data() {
    return {
      headerMenu: false,
      localeOptions: localeOptions,
      stores: [],
      selectedHost: "",
      recentOrders: [],
      newOrdersCount: 0
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) {
        return "";
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    "$i18n.locale"(to, from) {
      if (from !== to) {
        this.$router.go(this.$route.path);
      }
    },
    // La boutique sélectionnée peut changer depuis une autre page
    // (choix depuis le tableau de bord) : on resynchronise l'affichage.
    "$route"() {
      this.selectedHost = getSelectedHost() || "";
    }
  },
  computed: {
    isGlobalDashboard() {
      // Tableau de bord global : la sidebar est masquée (voir Body.vue),
      // le header occupe donc toute la largeur.
      return this.$route.path === "/dashboard/default";
    },
    headerClass() {
      if (this.isGlobalDashboard) return "page-main-header open";
      return !this.sidebar ? "page-main-header open" : "page-main-header";
    },
    sidebar() {
      return this.$store.state.menu.togglesidebar;
    },
    userEmail() {
      const user = firebase.auth().currentUser;
      return (user && (user.email || user.displayName)) || "";
    },
    initials() {
      return (this.userEmail || "A").slice(0, 2).toUpperCase();
    },
    currentStoreLabel() {
      return this.selectedHost || "All stores";
    }
  },
  methods: {
    ...mapActions(["setLang"]),
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
    },
    openHeader() {
      this.headerMenu = !this.headerMenu;
    },
    toggle_fullscreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          UserAuth.Logout();
          this.$router.replace("/auth/login").catch(err => err);
        });
    },
    changeLocale(locale) {
      this.setLang(locale);
    },
    handleResize() {
      this.width = window.innerWidth;
    },

    /* Liste des boutiques (menu de sélection du header). Un propriétaire
       ne voit que les boutiques qui lui appartiennent (profil /auth/me) ;
       le super-admin les voit toutes. */
    async loadStores() {
      try {
        let profile = UserAuth.getProfile();
        // Rafraîchit le profil (boutiques, abonnement) pour rester à jour,
        // même après un simple rechargement de page.
        try {
          const fresh = await firebase.auth().fetchProfile();
          UserAuth.setProfile(fresh);
          profile = UserAuth.getProfile();
        } catch (e) { /* on conserve le profil en cache */ }
        const snapshot = await firebase.firestore().collection("Sites").get();
        let stores = snapshot.docs.map(doc => {
          const data = doc.data();
          data.id = doc.id;
          return data;
        });
        if (profile && profile.role !== "superadmin" && Array.isArray(profile.sites)) {
          const owned = profile.sites.map(s => String(s).toLowerCase());
          stores = stores.filter(
            s => owned.indexOf(String(s.host || s.id).toLowerCase()) !== -1
          );
        }
        // Masque les boutiques exclues du sélecteur (voir HIDDEN_STORES).
        this.stores = stores.filter(s => {
          const host = String(s.host || s.id || "")
            .toLowerCase()
            .replace(/^www\./, "");
          return HIDDEN_STORES.indexOf(host) === -1;
        });
      } catch (e) {
        console.error("Header stores load error:", e);
      }
    },
    selectStore(store) {
      const host = store.host || store.id;
      if (!host || host === this.selectedHost) return;
      setSelectedHost(host);
      this.selectedHost = host;
      this.$router.push("/dashboard/site").catch(() => {});
    },
    goGlobalDashboard() {
      this.$router.push("/dashboard/default").catch(() => {});
    },
    goProfile() {
      this.$router.push("/account/profile").catch(() => {});
    },
    goSubscription() {
      this.$router.push("/account/subscription").catch(() => {});
    },

    /* Dernières commandes de toutes les boutiques (notifications). */
    async loadRecentOrders() {
      try {
        const snapshot = await firebase.firestore().collection("Commandes").get();
        const dayAgo = Date.now() - 24 * 60 * 60 * 1000;
        const orders = [];
        snapshot.forEach(doc => {
          const o = doc.data();
          // Les paniers abandonnés (mode_payment vide) ne sont pas des commandes.
          if (!o.mode_payment) return;
          const site = String(o.site || "").replace(/^www\./, "").trim();
          if (!site) return;
          orders.push({
            key: doc.id,
            site: site,
            transactionId: o.transactionId || doc.id,
            date: parseOrderDate(o.orderDate),
            customer: fullName(o) || "—",
            status: normalizeStatus(o.status),
            amt: parseNumber(o.amt)
          });
        });
        orders.sort(
          (a, b) => (b.date ? b.date.getTime() : 0) - (a.date ? a.date.getTime() : 0)
        );
        this.recentOrders = orders.slice(0, 5).map(o => ({
          key: o.key,
          site: o.site,
          transactionId: o.transactionId,
          customer: o.customer,
          status: o.status,
          dateLabel: formatDate(o.date, ""),
          amtLabel: formatMoney(o.amt, this.symbolFor(o.site))
        }));
        this.newOrdersCount = orders.filter(
          o => o.date && o.date.getTime() >= dayAgo
        ).length;
      } catch (e) {
        console.error("Header orders load error:", e);
      }
    },
    symbolFor(host) {
      const store = this.stores.find(s => (s.host || s.id) === host);
      return store && store.symbol ? store.symbol : "";
    },
    openOrderStore(order) {
      if (!order.site) return;
      setSelectedHost(order.site);
      this.selectedHost = order.site;
      this.$router.push("/dashboard/site").catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
/* Menu de sélection de boutique */
.store-switcher a {
  cursor: pointer;
}
.store-switcher .active > a {
  font-weight: 700;
}

/* Miniature (logo boutique ou image produit) */
.store-thumb {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 3px;
  margin-right: 8px;
  vertical-align: middle;
  background-color: #f3f6f9;
}

/* Avatar avec les initiales du compte connecté */
.avatar-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #4050f6;
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
}

/* Bloc identité du menu profil */
.profile-identity {
  padding: 4px 0 10px;
  border-bottom: 1px solid #e6e2e6;
  margin-bottom: 8px;
  font-size: 0.85rem;
  color: #717171;
  list-style: none;
}
</style>
